var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-breadcrumbs',{staticClass:"px-0 py-2",attrs:{"items":_vm.breadcrumbs}}),_c('h2',[_vm._v(" 積替運搬詳細 ")]),_c('accept-pickup-detail',{attrs:{"order-id":_vm.orderId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }